//水上乐斗 - 关末横幅
const Event = require("cocos/framework/components/event");
var WaterFightingWinBanner = xClass("WaterFightingWinBanner", Event, function () {
    return cc.CSLoader.createNode("cocos/watergun_watergun_end.csb")
})
let RES = [
    "packed/WaterFightingBanner.pack"
]

WaterFightingWinBanner.show = function (parent, playerInfos, newRecordInfos) {
    function onSuccess() {
        WaterFightingWinBanner.create(parent, playerInfos, newRecordInfos)
    }
    //
    let frame_res = DressManager.getInstance().getNeedFrameRes();
    RES = RES.concat(frame_res)
    preloadWithLoading(RES, onSuccess)
}
WaterFightingWinBanner.prototype.ctor = function (parent, playerInfos, newRecordInfos) {
    var self = this;
    self.bind(self);
    self.WaterFightingMgr = WaterFightingManager.getInstance();
    if (parent) {
        parent.addChild(self, 1000);
        self.initUI(playerInfos, newRecordInfos);
        let bottomY = -375;
        if (parent.activityRewards && $len(parent.activityRewards)) {
            bottomY -= 90;
        }
        //
        let posY = -display.height / 2 / (parent._scale || 1) + 222;
        if (cc.sys.os === cc.sys.OS_IOS && display.height / display.width > 1.78) {
            posY += 20;
        }

        self.y = Math.max(bottomY, posY);
    } else {
        self.removeFromParent(true);
    }
}

WaterFightingWinBanner.prototype.initUI = function (playerInfos, newRecordInfos) {
    let self = this;
    //
    let playerInfo1 = playerInfos[1];
    let harm1 = 0;//受到伤害

    let playerInfo2 = playerInfos[2];
    let harm2 = 0;

    for (let i = 0; i < newRecordInfos.length; i++) {
        let record = newRecordInfos[i];
        if (record) {
            if (record.attackerUid == UserManager.getInstance().uid) {
                harm2 += record.attackPoint;
            } else {
                harm1 += record.attackPoint;
            }
        }
    }

    self.refreshPlayer(1, playerInfo1, playerInfo1.hp + harm1);
    self.refreshPlayer(2, playerInfo2, playerInfo2.hp + harm2);
}

WaterFightingWinBanner.prototype.refreshPlayer = function (idx, data, startHp) {
    let self = this;
    let player = self.getChildByName("player" + idx);
    let hp = self.getChildByName("label_num" + idx);
    let name = self.getChildByName("label_name" + idx);
    let progress = self.getChildByName("propress_hp_" + idx);
    let progressBg = self.getChildByName("propress_light_" + idx);
    let streak = player.getChildByName("streak");
    let bufferSpr = streak.getChildByName("sheng");
    let bufferLabel = streak.getChildByName("label");
    //
    hp.setString(startHp);
    UIUtils.createNameWithUserShow(name, data.profile.nickname, 120, data.profile.userShow)
    const comboLevelNum = data.comboLevelNum;
    const MaxWinning = self.WaterFightingMgr.getMaxWinningStreak();
    if (comboLevelNum > MaxWinning) {
        bufferLabel.setString(MaxWinning + "+");
        bufferSpr.x += 7;
    } else {
        bufferLabel.setString(comboLevelNum);
    }
    //
    let newNode = cc.Node.create();
    newNode.setContentSize(76, 76);
    player.addChild(newNode);
    DressManager.getInstance().addHeadFrameByUseShow(newNode, data.profile.userShow, 0.8);
    HeadImageLoader.loadImage(newNode, data.profile.avatar);
    streak.setLocalZOrder(99);
    //
    const maxLen = 212;
    const curHp = data.hp;
    const fullHp = self.WaterFightingMgr.getCurFullHP();
    progress.width = maxLen * startHp / fullHp || 1;
    progressBg.width = progress.width;

    let temp = {
        progress,
        startRate: startHp / fullHp,
        endRate: curHp / fullHp,
        len: maxLen,
        head: player,
        time: 0.85,
        hpLabel: hp,
        fullHp,
    }

    //winPanel弹窗动画300ms、星星动画550ms、接口请求 + 资源加载估计为 50ms
    let timer = setTimeout(() => {
        self.WaterFightingMgr.showProgressAct(temp, () => {
            hp.setString(curHp);
            progressBg.runAction(cc.FadeTo.create(0.2, 0));
        });
    }, 850);
    //
    if (!self.timers) {
        self.timers = [];
    }
    self.timers.push(timer);
}

WaterFightingWinBanner.prototype.cleanup = function () {
    let self = this;
    if (self.timers) {
        for (let i = 0; i < self.timers.length; i++) {
            clearTimeout(self.timers[i]);
        }
        self.timers = [];
    }
    console.log("WaterFightingWinBanner cleanup");
    ResManager.release(RES);
}

module.exports = WaterFightingWinBanner;